import {color_red_default, color_red_default_t20, color_white} from "../../../../../constants/colors";

export const styles = {
    profileImageUpdatingContainer: {
        backgroundColor: color_white,
        borderRadius: 20,
        width: 530,
        height: 163,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly"
    },
    profileImageUpdatingActionContainer: {
        minWidth: 72,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer"
    },
    profileImageUpdatingActionIcon: {
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: "#FEEFEF",
        color: color_red_default,
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 13
    },
    profileImageUpdatingImageCircle: {
        width: 130,
        height: 130,
        borderRadius: "50%",
        objectFit: "cover"
    },
    profileImageUpdatingWaitingContainer: {
        position: "absolute",
        borderRadius: 20,
        width: 530,
        height: 163,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        alignItems: "center",
        justifyContent: "center"
    },
}